export enum ActorLayoutVariant {
  DefaultActor,
  NaturalPerson,
  InsuredActor,
  UnemploymentActor,
  BorrowerActors,
  ActorWithDefaultDocumentsActor,
  BorrowerWithDocumentsActor,
  UpiActor,
  LegalEntityContact,
  LegalProtectionActor,
}
